module.exports = __webpack_public_path__ + "img/projecto-3.3dc9856e.png";